import './Footer.scss';

import React from 'react';

type FooterProps = {};

const Footer = (props: FooterProps): React.ReactElement => {
  return (
    <div className="footer">
      <span></span>
    </div>
  );
};

export default Footer;
